import React from 'react';
import { Grid } from '@nike/nike-design-system-components';
import styled, { CSSObject } from '@emotion/styled';
import { LayoutProps } from '../../types/LayoutProps';

const StyledBox = styled.div(
  (): CSSObject => ({
    backgroundColor: 'white',
    position: 'fixed',
    top: '0',
    left: '0',
    width: 110 + 'px',
    height: 100 + '%',
    textAlign: 'center',
  })
);

const StyledContentBox = styled.div<{backgroundColor:string}>(
    ({backgroundColor}): CSSObject => ({
        backgroundColor:`${backgroundColor}`,
        position: 'fixed',
        top: 0,
        left: 110 + 'px',
        height: 100 + '%',
        width: 'calc(100% - 110px)',
        textAlign: 'left',
        overflow: 'auto'
    })
);

const Layout: React.FC<LayoutProps> = ({ justifyContent, justifyItems, alignContent, alignItems, children }) => {

  return (
    <>
      <StyledBox>
        <i
          className="g72-swoosh"
          aria-label="nike-logo"
          style={{
            fontSize: '20px',
            marginTop: '24px',
          }}
        ></i>
      </StyledBox>
      <StyledContentBox backgroundColor="#F5F5F5">
        <Grid
          data-testid="grid"
          justifyContent={justifyContent}
          justifyItems={justifyItems}
          alignContent={alignContent}
          alignItems={alignItems}
          rowGap="19px"
          style={{ height: 100 + 'vh' }}
        >
          {children}
        </Grid>
      </StyledContentBox>
    </>
  );
};

export default Layout;
